export default __webpack_public_path__ + "static/media/palette.06018e4d.svg";